import { ENVIRONMENT_ID_PREFIX } from "../../constants/config";

export const prefixEnvironmentSdrn = (id: string): string => {
  return sdrn(id, ENVIRONMENT_ID_PREFIX);
};

export const prefixUserSdrn = (id: string, prefix: string): string => {
  return sdrn(id, prefix);
};

const sdrn = (id: string, prefix: string): string => {
  const checkId = checkString(id);

  if (checkId.startsWith(prefix)) {
    return id;
  }

  return `${prefix}${id}`;
};

const checkString = (text: string) => ({
  // Not using 'String.prototype.startsWith()' for IE compatability
  startsWith: (startsWith: string) => {
    return text.indexOf(startsWith) === 0;
  },
});
